import {
  firestoreSlotsDesdeEstado,
  resumenDisponibilidad,
  validarDisponibilidadSemana,
} from './serviciosDisponibilidad.js';
import { esRubroServicioValido } from './serviciosRubros.js';

export const MAX_RUBROS_PROFESIONAL = 3;

/**
 * @param {unknown} rubrosRaw
 * @returns {string[]}
 */
export function normalizarRubrosPerfil(rubrosRaw) {
  const arr = Array.isArray(rubrosRaw) ? rubrosRaw : [];
  const out = [];
  for (const r of arr) {
    const id = String(r || '').trim();
    if (!id || !esRubroServicioValido(id)) continue;
    if (!out.includes(id)) out.push(id);
    if (out.length >= MAX_RUBROS_PROFESIONAL) break;
  }
  return out;
}

/**
 * @param {{
 *   rubros?: string[],
 *   disponibilidad_semana_estado?: Record<number, { desde: string, hasta: string }[]>,
 *   disponibilidad?: string,
 *   descripcion_publica?: string,
 *   frase_personal?: string
 * }} data
 */
export function validarPayloadMiPerfilServicios(data) {
  const rubros = normalizarRubrosPerfil(data?.rubros);
  if (rubros.length === 0) {
    return { ok: false, error: 'Elegí al menos una especialidad.' };
  }
  const slots = firestoreSlotsDesdeEstado(data?.disponibilidad_semana_estado || {});
  const vDisp = validarDisponibilidadSemana(slots);
  if (!vDisp.ok) return vDisp;
  const disponibilidad = resumenDisponibilidad(slots);
  const descripcion_publica = String(data?.descripcion_publica || '').trim();
  if (descripcion_publica.length > 2000) {
    return { ok: false, error: 'Texto demasiado largo.' };
  }
  const frase_personal = String(data?.frase_personal || '').trim().slice(0, 180);
  if (frase_personal.length > 180) {
    return { ok: false, error: 'La frase personal es demasiado larga.' };
  }
  return {
    ok: true,
    value: { rubros, disponibilidad, disponibilidad_semana: slots, descripcion_publica, frase_personal },
  };
}
